<div class="med-avatar-container">
  <ng-container *ngIf="initials; else elseBlock"> {{ initials }} </ng-container>

  <ng-template #elseBlock>
    <med-icon-avatar size="16"></med-icon-avatar>
  </ng-template>
</div>
